import Navbar from "./components/Navbar";
import Card from "./components/Card";
import Main from "./components/Main";
import "./output.css"
import { web3Accounts, web3Enable, web3FromSource } from '@reef-defi/extension-dapp';
import { ApiPromise, WsProvider } from '@polkadot/api';
import {useState,useEffect} from 'react';
import {BigNumber} from 'ethers'
import Result from "./components/Result";

function App() {
  const SINGLE_REEF = BigNumber.from("1000000000000000000");
  
  const [paymentText,setText] = useState("make transaction to know who won!")
  const [player1, setPlayer1] = useState('bluesword');
  const [player2, setPlayer2] = useState('');
  const [account, setAccount] = useState(null);
  const [api, setApi] = useState();
  const [stopped, setStop] = useState(false);
  const [paymentDone, makePayment] = useState(false);
  const [verdict, makeVerdict] = useState(false);


  const address = "5DntyUhk87kwiWM8CdYuyhPwGqAhPhK74AGNQHkC2eiaB4om"

  const apiInitialiser = async()=>{
    const wsProvider = new WsProvider('wss://rpc-testnet.reefscan.com/ws');
    const x = await ApiPromise.create({ provider: wsProvider });
    setApi(x);
  }

  async function checkExtension(){
    const extensions = await web3Enable('reef');
      if (extensions.length === 0) {
        alert("Please install Reef extensions");
        return;
      }
      const allAccounts = await web3Accounts();
      setAccount(allAccounts[0]);
      console.log(account)
  }

  const getResult = ()=>{
    const randomBool = Math.random() > 0.4 ? true : false;
    return randomBool;
  }
  const signerFunc = async ()=>{
    await checkExtension();
    if(!account)return;
    const injector = await web3FromSource(account.meta.source);
    console.log(account.meta.name);
    if(!api)return;
    const val = 10;
    const TRANSFER_AMOUNT = SINGLE_REEF.mul(val);
    console.log(address)
    console.log(val);
      const transferExtrinsic = api.tx.balances.transfer(address, TRANSFER_AMOUNT.toString());
      transferExtrinsic.signAndSend(account.address, { signer: injector.signer }, ({ status }) => {
        if (status.isInBlock) {
            console.log(`Completed at block hash #${status.asInBlock.toString()}`);
            makePayment(true);
            let result = getResult();
            makeVerdict(result);
        } else {
            console.log(`Current status: ${status.type}`);
        
        }
    }).catch((error) => {
      alert(error);
        console.log(':( transaction failed', error);
        window.location.reload();
        
    });
  }

  const handleGame = async()=>{
    setStop(true);
    await signerFunc();
  }

  useEffect(() => {
    apiInitialiser();
  }, [])

  return (
    <div className="App">
      <Navbar/>
      {account?
      <div className="flex justify-evenly my-10">
        {!stopped?
        <>
        <div>
       <p className="border-b-2 my-2 border-gray-600"> Player-1 </p>
      <Card isComp={false} isStopped={stopped} playerDetails={{"player":player1,"setFunc":setPlayer1}} />
        </div>
        <div>
     <p className="border-b-2 my-2 border-gray-600">Player-2 <span className="font-xbody uppercase text-xl text-gray-400">[ Comp ]</span> </p>
      <Card isComp={true}  isStopped={stopped} playerDetails={{"player":player2,"setFunc":setPlayer2}}  />
        </div>
        </>:
        < >
        {paymentDone?
      <Result verdict={verdict} char={player1} />:
      "make payment"
      }
        </>
      }
      
        <div className="basis-1/2 ">
          <h2 className="font-xbody text-4xl tracking-wider ">Game Rules</h2>
          <br />
          <li className="text-2xl tracking-wider font-xbody" >The longer you take to choose the character, the lower will be the chances of winning. as wait time increases anger of computer & the power of character it chooses. <br /> <span className="text-xl font-xbody">[ Observe the speed of selection of computer ]</span> </li>
          <li className="text-2xl tracking-wider font-xbody" >There isn't the MOST POWERFUL CHARACTER in this game, so chances of winning is fair . i.e 50% in each case.</li>
          <br /><br />
        Connected as  {account.meta.name} <br />
        Address : {account.address}
        <br />
        {paymentDone?
        <button onClick={()=>window.location.reload()} className="py-2 px-4 border-dashed border-gray-400 border-4  tracking-widest">
          Play Again
        </button>
        :
        <div className="py-24">
        <button onClick={handleGame} className="py-2 px-4 border-dashed border-gray-400 border-4  tracking-widest">
        Select Character
      </button>
      </div>
        }
        </div>
  
      </div>
      :
      <div className="font-xbody flex justify-center h-max justify-self-center items-center flex-col">
        <Main/>
        <button onClick={checkExtension} className="py-2 px-4 border-dashed border-gray-400 border-4  tracking-widest">Connect</button>
        <p>Connect your wallet to access the game</p>
      </div>
      }
    </div>
  );
}

export default App;
